import Axios from "axios";
import {
  SET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT,
  UNSET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT,
} from "@/store/mutation-types";
import {
  getShiftWiseAttendanceSummaryReport,
} from "@/store/api";

const state = {
  shiftWiseAttendanceSummaryReport: [],
};

const getters = {
  getShiftWiseAttendanceSummaryReport(state) {
    return state.shiftWiseAttendanceSummaryReport;
  },
};

const mutations = {
  [SET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT](state, data) {
    state.shiftWiseAttendanceSummaryReport = data;
  },
  [UNSET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT](state) {
    state.shiftWiseAttendanceSummaryReport = [];
  },
};

const actions = {
  getShiftWiseAttendanceSummaryReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getShiftWiseAttendanceSummaryReport}`, { params: data })
        .then((response) => {
          commit(SET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_SHIFT_WISE_ATTENDANCE_SUMMARY_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

